import {Component, Input} from '@angular/core';
import {environment} from '../../../../../../environments/environment';

@Component({
  selector: 'app-home-why-card-pink',
  imports: [],
  templateUrl: './home-why-card-pink.component.html',
})
export class HomeWhyCardPinkComponent {

  @Input()
  reduced = true
  protected readonly environment = environment;
}
